import React, { useEffect, useRef, useState } from "react";
import { Html5Qrcode, Html5QrcodeSupportedFormats } from "html5-qrcode";
import { Modal } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import "./scanner.css";
import { setAlertWithTitle } from "../../../../../utility/Redux/modal";
import AlertModalTwoButton from "../../../../../utility/component/modals/alertWithTwoButton";
import { selectWidth } from "../../../../../utility/Redux/profile";

const QRCodeScanner = ({ onDetected,onClose, status, setCamera }) => {
  const dispatch = useDispatch();
  const windowWidth = useSelector(selectWidth);

  const scannerRef = useRef(null);
  const lineRef = useRef(null);

  const [devices, setDevices] = useState("");
  const [cameraList, setCameraList] = useState([]);

  const defaultCamera = localStorage.getItem("defaultCamera");

  const [alertTwoButtonModal, setAlertTwoButtonModal] = useState({
    title: "",
    msg: "",
    status: false,
  });

  /* ---------------- CONFIG ---------------- */

  const config = {
    fps: 30,
    qrbox: { width: 200, height: 200 },
    supportedScanTypes: [
      Html5QrcodeSupportedFormats.CODE_128,
      Html5QrcodeSupportedFormats.EAN_13,
      Html5QrcodeSupportedFormats.QR_CODE,
    ],
  };

  /* ---------------- HELPERS ---------------- */

  const getCameraLabel = (label = "") => {
    const l = label.toLowerCase();
    if (l.includes("front")) return "Front Camera";
    if (l.includes("back") || l.includes("rear")) return "Back Camera";
    return "Camera";
  };

  const animateScannerLine = () => {
    if (lineRef.current) {
      lineRef.current.style.display = "block";
    }
  };

  const stopScanner = async () => {
    console.log(scannerRef)
    if (scannerRef.current) {
      try {
        await scannerRef.current.stop();
        await scannerRef.current.clear();
      } catch (e) {}
    }
  };

  /* ---------------- GET CAMERAS ---------------- */

  useEffect(() => {
    if (!status) return;

    Html5Qrcode.getCameras()
      .then((list) => {
        if (!list?.length) {
          dispatch(
            setAlertWithTitle({
              title: "Alert",
              msg: "No camera found",
            })
          );
          return;
        }

        setCameraList(list);

        const saved = list.find((c) => c.id === defaultCamera);
        const back = list.find((c) =>
          c.label.toLowerCase().includes("back")
        );

        setDevices(saved?.id || back?.id || list[0].id);
      })
      .catch(() => {
        dispatch(
          setAlertWithTitle({
            title: "Alert",
            msg: "Camera permission denied",
          })
        );
      });
  }, [status]);

  /* ---------------- START SCANNER ---------------- */
  console.log(status)

  useEffect(() => {
    if (!status || !devices) {
      console.log(status)
      if (!status) {
        stopScanner().then(() => {
           console.log('hi')
        }).catch(() => {
          console.log("h2")
         })
      }
      return;

    }
    const html5QrCode = new Html5Qrcode("reader");
    scannerRef.current = html5QrCode;

    html5QrCode
      .start(
        devices,
        config,
        async (decodedText) => {
          onDetected?.(decodedText);
          animateScannerLine();
          await stopScanner();
          setCamera("");
        },
        () => {}
      )
      .then(() => setCamera?.(html5QrCode))
      .catch(console.error);
  }, [devices, status]);

  /* ---------------- ACTIONS ---------------- */

  const handleSwitchCamera = async () => {
    if (cameraList.length < 2) return;

    const current = cameraList.findIndex((c) => c.id === devices);
    const next = (current + 1) % cameraList.length;

    await stopScanner();
    setDevices(cameraList[next].id);
  };

  const handleRefresh = async () => {
    await stopScanner();
    setDevices("");
    setTimeout(() => {
      setDevices(cameraList[0]?.id);
    }, 300);
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const qr = new Html5Qrcode("reader");
    try {
      const result = await qr.scanFile(file, true);
      onDetected?.(result);
      setCamera("");
    } catch {
      dispatch(
        setAlertWithTitle({
          title: "Invalid QR",
          msg: "Could not scan QR from image",
        })
      );
    }
  };

  /* ---------------- UI ---------------- */

  const styleMobile = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  };

  const selectedCamera = cameraList.find((c) =>  c.id === devices)?.id || "";

  return (
    <Modal open={status}>
      <div style={styleMobile} className="scanner-wrapper">
        <div className="scanner-card">
          {/* Header */}
          <div className="scanner-header">
            <span>Scan QR Code</span>
            <button className="close-btn" onClick={() => {
              setCamera("")
              stopScanner()
              onClose()
            }}>
              ✕
            </button>
          </div>

     

          {/* Scanner */}
          <div className="scanner-box">
            <div className="scanner-line" ref={lineRef} />
            <div id="reader" />
          </div>

          {/* Actions */}
          <div className="scanner-actions">
            <button className="action-btn" onClick={handleSwitchCamera}>
              <i className="bi bi-camera" /> Switch
            </button>

            <label className="action-btn">
              <i className="bi bi-image" /> Upload
              <input
                type="file"
                hidden
                accept="image/*"
                onChange={handleImageUpload}
              />
            </label>

            <button className="action-btn" onClick={handleRefresh}>
              <i className="bi bi-arrow-clockwise" /> Refresh
            </button>

          
          </div>

          <AlertModalTwoButton
            details={alertTwoButtonModal}
            setAlertTwoButtonModal={setAlertTwoButtonModal}
          />
        </div>
      </div>
    </Modal>
  );
};

export default QRCodeScanner;
